<div class="card card-custom h-100">
  <div class="card-header">
    <div class="card-title">
      <!--      <h3 class="card-label">-->
      <!--        -->
      <!--        {{ data.isNew ? 'Create Workflow' : getTitle() | titlecase}}-->
      <!--      </h3>-->
      <div>
        <div class="card-label d-flex align-items-start">
          <h3>
            {{
              data.isNew ? 'Create Workflow' : (getWorkflowName() + ' - ' + getTitle() | titlecase)
            }}
            ( {{ currentStatusNumber.number || 0 }} of {{ maxStatusNumber.number || 0 }} )
          </h3>
          <img
            *ngIf="(templateResources$ | async)?.length"
            src="./assets/media/svg/icons/General/process-nav.svg"
            alt="Process Navigator Icon"
            width="24px"
            class="cursor-pointer ml-4"
            (click)="openProcessNavView($event)"
          />
        </div>
        <div
          class="font-size-sm font-weight-bold text-muted"
          [innerHTML]="!data.isNew ? data.header : ('' | safe : 'html')"
        ></div>
      </div>
    </div>
    <!-- <div style="">
      <button style="display: none;width: 30px; margin-right:5px" type="button" mat-raised-button color="accent"
              matTooltip="Lock Workflow" (click)="onLockWorkflowClick()" [disabled]="isSubmitting" *ngIf="!isCreate">
        <span class="material-icons">
          lock
        </span>
      </button>

      <button style="width: 150px;" type="button" mat-raised-button color="warn" matTooltip="Cancel Workflow"
              (click)="onCancelWorkflowClick()" [disabled]="isSubmitting" *ngIf="!isCreate">Cancel Workflow
      </button>&nbsp;
    </div> -->
    <div class="card-toolbar d-flex align-items-center justify-content-between w-50">
      <mat-form-field
        *ngIf="(templateBlockers$ | async)?.length"
        appearance="standard"
        style="width: 200px !important; padding-left: 15px"
      >
        <mat-label>Blocker/s</mat-label>
        <mat-select
          [formControl]="blockersControl"
          multiple
          [compareWith]="compareBlockersFn"
          (closed)="handleBlockers()"
        >
          <mat-option
            *ngFor="let blocker of templateBlockers$ | async; let idx = index"
            [value]="blocker"
          >
            <span
              style="width: 98px"
              class="label label-inline label-lg"
              [ngClass]="getBlockerClass(idx)"
              >{{ blocker.code }}</span
            >
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="d-flex align-items-center">
        <div class="nav-item" *ngIf="!isDone">
          <a
            class="nav-link"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            style="padding-right: 0"
          >
            <span class="nav-icon">
              <button
                class="btn btn-sm btn-clean mr-2 header-buttons"
                mat-button
                matTooltip="Follow-up"
                (click)="openFollowUpDialog()"
                *ngIf="!this.data.fromCalendar"
              >
                <i class="flaticon-calendar-with-a-clock-time-tools"></i>
              </button>
            </span>
          </a>
        </div>
        <div class="nav-item" *ngIf="!isDone">
          <a
            class="nav-link dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            style="padding-right: 0"
          >
            <span class="nav-icon">
              <button
                matTooltip="Comments"
                class="btn btn-sm btn-clean mr-2 header-buttons"
                mat-button
              >
                <i class="flaticon-comment"></i>
              </button>
            </span>
          </a>
          <div
            class="dropdown-menu dropdown-menu-xl dropdown-menu-right px-5"
            (click)="$event.stopPropagation()"
            style="
              width: 500px;
              position: absolute;
              will-change: transform;
              padding: 0 !important;
              top: 0;
              left: 0;
              transform: translate3d(1065px, 59px, 0px);
              overflow: hidden;
              border-radius: 0;
            "
          >
            <kt-comments
              [id]="data.workflow.workflow_queue.id"
              [comments]="comments"
              [type]="'workflow_queues'"
              [height]="65"
            ></kt-comments>
          </div>
        </div>
        <div class="nav-item drop">
          <a
            class="nav-link"
            aria-haspopup="true"
            aria-expanded="false"
            style="padding-right: 30px"
          >
            <span class="nav-icon">
              <button
                matTooltip="History"
                class="btn btn-sm btn-clean mr-2 header-buttons"
                mat-button
                (click)="toggleMenu($event)"
              >
                <i class="fas fa-history"></i>
              </button>
            </span>
          </a>
          <div
            class="menu scroll px-3 py-5"
            [style.display]="showMenu ? 'block' : 'none'"
            [perfectScrollbar]="{ wheelPropagation: false }"
          >
            <kt-workflow-history
              [loadingHistory]="loadingHistory"
              [history]="history"
              [wqHistory]="wqHistory"
              [wqCommentsHistory]="wqCommentsHistory"
            ></kt-workflow-history>
          </div>
        </div>
        <div class="btn-group btn-group-sm">
          <button
            type="button"
            class="btn btn-outline-secondary"
            [disabled]="isPickedSub.value || isDone"
            (click)="assignSelf($event)"
          >
            Pick Up
          </button>
          <div ngbDropdown class="assign btn-group btn-group-sm">
            <button ngbDropdownToggle type="button" class="btn btn-outline-secondary">
              Assign
            </button>
            <div ngbDropdownMenu class="dropdown-menu">
              <kt-general-autocomplete
                #assignToAutocomplete
                [label]="'Assign To'"
                [placeholder]="'Select Assignee/s'"
                [appearance]="'standard'"
                [loadItemsFunction]="getAssignToAutocomplete"
                [optionFormatter]="formatAssignToOption"
                [valueFormatter]="formatAssignToOption"
                [formatNewObjectFn]="formatNewAssignTo"
                [control]="assignToAutocomplete"
                [objects]="assignToAutocomplete.value"
                [required]="false"
                [readOnly]="isDone"
                [chipList]="true"
                [dataPath]="'data'"
              ></kt-general-autocomplete>
            </div>
          </div>
        </div>
        <div class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="nav-icon"><i class="ki ki-bold-more-ver"></i></span>
          </a>
          <div class="dropdown-menu dropdown-menu-md dropdown-menu-right py-5">
            <ul class="navi navi-hover">
              <li class="navi-item">
                <a
                  class="navi-link"
                  (click)="loadOldWorkflowData()"
                  *ngIf="
                    !isCreate &&
                    data.workflow.workflow_queue.old_workflow_queue_id !== null &&
                    !isDone
                  "
                >
                  <span class="navi-icon svg-icon svg-icon-primary svg-icon-x pr-3"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24" />
                        <path
                          d="M1.5,5 L4.5,5 C5.32842712,5 6,5.67157288 6,6.5 L6,17.5 C6,18.3284271 5.32842712,19 4.5,19 L1.5,19 C0.671572875,19 1.01453063e-16,18.3284271 0,17.5 L0,6.5 C-1.01453063e-16,5.67157288 0.671572875,5 1.5,5 Z M18.5,5 L22.5,5 C23.3284271,5 24,5.67157288 24,6.5 L24,17.5 C24,18.3284271 23.3284271,19 22.5,19 L18.5,19 C17.6715729,19 17,18.3284271 17,17.5 L17,6.5 C17,5.67157288 17.6715729,5 18.5,5 Z"
                          fill="#000000"
                        />
                        <rect
                          fill="#000000"
                          opacity="0.3"
                          x="8"
                          y="5"
                          width="7"
                          height="14"
                          rx="1.5"
                        />
                      </g>
                    </svg>
                  </span>
                  <span class="navi-text">Load From Old Workflow</span>
                </a>
              </li>
              <li class="navi-item">
                <a class="navi-link" (click)="cancelAndRecreate()" *ngIf="!isCreate && !isDone">
                  <span class="navi-icon svg-icon svg-icon-success svg-icon-x">
                    <!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2020-12-28-020759/theme/html/demo1/dist/../src/media/svg/icons/Communication/Reply.svg--><svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24" />
                        <path
                          d="M21.4451171,17.7910156 C21.4451171,16.9707031 21.6208984,13.7333984 19.0671874,11.1650391 C17.3484374,9.43652344 14.7761718,9.13671875 11.6999999,9 L11.6999999,4.69307548 C11.6999999,4.27886191 11.3642135,3.94307548 10.9499999,3.94307548 C10.7636897,3.94307548 10.584049,4.01242035 10.4460626,4.13760526 L3.30599678,10.6152626 C2.99921905,10.8935795 2.976147,11.3678924 3.2544639,11.6746702 C3.26907199,11.6907721 3.28437331,11.7062312 3.30032452,11.7210037 L10.4403903,18.333467 C10.7442966,18.6149166 11.2188212,18.596712 11.5002708,18.2928057 C11.628669,18.1541628 11.6999999,17.9721616 11.6999999,17.7831961 L11.6999999,13.5 C13.6531249,13.5537109 15.0443703,13.6779456 16.3083984,14.0800781 C18.1284272,14.6590944 19.5349747,16.3018455 20.5280411,19.0083314 L20.5280247,19.0083374 C20.6363903,19.3036749 20.9175496,19.5 21.2321404,19.5 L21.4499999,19.5 C21.4499999,19.0068359 21.4451171,18.2255859 21.4451171,17.7910156 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                        />
                      </g>
                    </svg>
                  </span>
                  <span class="navi-text">Cancel and Recreate</span>
                </a>
              </li>
              <li class="navi-item">
                <a class="navi-link" (click)="onCancelWorkflowClick()" *ngIf="!isCreate && !isDone">
                  <span class="navi-icon"><i class="flaticon-delete text-danger ml-1"></i></span>
                  <span class="navi-text">Cancel Workflow</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  <div *ngIf="isLoading" class="workflow-spinner">-->
  <!--    <mat-spinner [diameter]="20"></mat-spinner>-->
  <!--  </div>-->
  <div
    class="row margin-0 card-body navi-hover"
    style="
      display: flex;
      align-content: flex-start;
      height: calc(100% - 150px);
      max-height: unset !important;
    "
  >
    <div *ngIf="isCreate" class="col-12">
      <mat-form-field
        appearance="outline"
        class="example-form-field"
        style="padding: 0; width: 100%"
      >
        <mat-label>Workflow</mat-label>
        <mat-select placeholder="Select Workflow" [formControl]="workflow">
          <mat-option
            value="{{ workflowOp.id }}"
            *ngFor="let workflowOp of workflowsList | async"
            >{{ workflowOp.name }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="loadingWorkflowData" class="workflow-spinner col-12">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
    <div *ngIf="!isCreate" class="col-12"></div>
    <div *ngIf="!loadingWorkflowData && (workflow.value || data.workflow)" class="col-12 h-100">
      <div class="row h-100">
        <div
          *ngIf="showReadOnlyData"
          [ngClass]="
            (isDone ? 'col-12 pt-0' : 'col-6 pt-0') + ' form-container scroll read-only-data'
          "
          [perfectScrollbar]="{ wheelPropagation: false }"
        >
          <div *ngIf="false">
            <div *ngIf="attachments.length > 1" class="row justify-content-center">
              <div class="col-2">
                <button
                  type="button"
                  mat-icon-button
                  color="primary"
                  [disabled]="index === 0"
                  (click)="Previous()"
                >
                  <mat-icon>keyboard_arrow_left</mat-icon>
                </button>
              </div>
              <div class="col-2 pt-3">{{ index + 1 }} of {{ attachments.length }}</div>
              <div class="col-1">
                <button
                  type="button"
                  mat-icon-button
                  color="primary"
                  [disabled]="index === attachments.length - 1"
                  (click)="Next()"
                >
                  <mat-icon>keyboard_arrow_right</mat-icon>
                </button>
              </div>
            </div>
            <ngx-extended-pdf-viewer
              [src]="attachments[index].url"
              [useBrowserLocale]="true"
              [height]="'50vh'"
            ></ngx-extended-pdf-viewer>
          </div>
          <formio [form]="readOnlyField" [submission]="readOnlyValue" [readOnly]="true"></formio>
        </div>
        <div
          *ngIf="!isDone"
          [ngClass]="(showReadOnlyData ? 'col-6' : 'col-12') + ' form-container scroll'"
          [perfectScrollbar]="{ wheelPropagation: false }"
        >
          <formio
            [form]="fields"
            #formio
            (customEvent)="handleFormEvent($event)"
            (change)="onChange($event)"
            [submission]="modelMappedData"
            [readOnly]="isSubmitting"
          ></formio>
        </div>
      </div>
    </div>
  </div>
  <mat-dialog-actions align="end" style="padding: 18px 36px">
    <div *ngIf="!isCreate" style="width: 20%; display: flex; justify-content: flex-start">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            class="prevButton mr-12"
            type="button"
            mat-icon-button
            [color]="!parentId ? '' : 'primary'"
            (click)="changeReadOnlyForm('PREV')"
            [disabled]="!parentId"
          >
            <mat-icon inline="true">arrow_back</mat-icon>
          </button>
          <button
            class="nextButton mr-12"
            type="button"
            mat-icon-button
            [color]="currentId === rightPanelId ? '' : 'primary'"
            (click)="changeReadOnlyForm('NEXT')"
            [disabled]="currentId === rightPanelId"
          >
            <mat-icon>arrow_forward</mat-icon>
          </button>
          <a
            class="btn btn-text-dark-50 mr-3"
            (click)="openPDF()"
            [hidden]="!(attachments && attachments.length > 0)"
          >
            <i class="flaticon-attachment text-primary"></i>{{ 'SHOW' }}
          </a>
        </div>
      </div>
    </div>
    <div style="width: 80%; display: flex; justify-content: flex-end">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            cdkFocusInitial
            matTooltip="Close"
            (click)="onCancelClick()"
            [disabled]="isSubmitting"
          >
            Close</button
          >&nbsp;
          <!--          <button *ngIf="!isCreate" type="button" mat-raised-button color="primary" (click)="viewAttachments = !viewAttachments" [disabled]="!(attachments && attachments.length > 0)">View/Hide Attachments-->
          <!--          </button>&nbsp;-->
          <button
            *ngIf="!isCreate && !isDone"
            type="submit"
            mat-raised-button
            color="primary"
            matTooltip="Save changes"
            style="margin-right: 5px"
            [disabled]="isSubmitting"
            (click)="onSubmit(false)"
          >
            Save
          </button>
          <button
            *ngIf="isCreate"
            type="submit"
            mat-raised-button
            color="primary"
            matTooltip="Save changes"
            (click)="onSubmit(true)"
            [disabled]="isSubmitting || workflow.value === null"
          >
            Create
          </button>
          <button
            *ngIf="!isCreate && !isDone"
            type="submit"
            mat-raised-button
            color="primary"
            matTooltip="Save changes & Next"
            (click)="onSubmit(true)"
            [disabled]="isSubmitting"
          >
            Save & {{ this.isLastStep ? 'Finish' : 'Next' }}
          </button>
        </div>
      </div>
    </div>
  </mat-dialog-actions>
</div>
